var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarMine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66251 1.01772L10.5873 4.18552C10.7341 4.27994 10.917 4.29917 11.0803 4.23734L16.5567 2.16304C16.6404 2.13132 16.725 2.20752 16.7022 2.29412L15.2086 7.95434C15.164 8.1232 15.2022 8.3032 15.3115 8.43942L18.9756 13.0059C19.0316 13.0758 18.9853 13.1797 18.8959 13.1848L13.0507 13.5142C12.8762 13.5241 12.7168 13.6161 12.6211 13.7623L9.41413 18.659C9.36505 18.7339 9.25181 18.7221 9.21936 18.6386L7.09854 13.1813C7.03525 13.0184 6.89844 12.8953 6.72985 12.8494L1.08127 11.3128C0.994851 11.2893 0.971145 11.178 1.0405 11.1213L5.57498 7.41584C5.71021 7.30534 5.785 7.13724 5.77654 6.96281L5.49294 1.11567C5.4886 1.02621 5.58718 0.969265 5.66251 1.01772Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMine);
export default __webpack_public_path__ + "static/media/star-mine.4430a82f268ebf71315c89447d67ff32.svg";
export { ForwardRef as ReactComponent };